import React, { FC, useState, useCallback, useContext } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import timeIcon from '../../../assets/REDESIGN_Assets/AlbumScreen/time-icon.svg'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import { PdfTIle, AlbumTile } from '../style/AlbumScreenStyle'
import pdfDownloadIcon from '../../../assets/REDESIGN_Assets/AlbumScreen/pdf-download-icon.svg'
import pdfIcon from '../../../assets/REDESIGN_Assets/AlbumScreen/pdf-icon.svg'

interface FavoritesModeInterface {
  albumName: string
  favorites: any
  history: any
  albumId: any
  challengeMode: any
  videos: any
}

const FavoritesMode: FC<FavoritesModeInterface> = ({
  albumName,
  favorites,
  history,
  albumId,
  challengeMode,
  videos,
}) => {
  return (
    <GenericColumn
      margin={'5% auto 0 auto'}
      maxWidth={'1000px'}
      className="standard"
      width={isMobile ? '95%' : '50%'}
      flexDir="column"
    >
      <GenericTextSpan fWeight={'bold'} fSize={'1.6rem'} margin={'0 0 2% 0'}>
        {albumName && albumName}
      </GenericTextSpan>

      <GenericTextSpan fSize={'1.2rem'} margin={'0 0 2% 0'}>
        Ulubione
      </GenericTextSpan>

      <GenericColumn>
        {videos && videos.videos.length ? (
          videos.videos.map((favVid: any) =>
            favorites.map(
              (favorite: any) =>
                favorite.video_id === favVid.vimeo_video_id && (
                  <AlbumTile
                    className={
                      favVid && favVid.is_locked
                        ? ' album-tile'
                        : 'active album-tile'
                    }
                    onClick={
                      favVid && !favVid.is_locked
                        ? () => {
                            history.push({
                              pathname: `/video/${favVid.vimeo_video_id}`,
                              state: {
                                albumName: albumName,
                                videoOrder: favVid.video_order,
                                isIntro: favVid.is_intro,
                                videoId: favVid.vimeo_video_id,
                                albumId: albumId,
                                challengeMode: challengeMode,
                                videoName: favVid.name,
                              },
                            })
                          }
                        : null
                    }
                  >
                    <GenericColumn width={'32%'}>
                      <GenericIcon
                        borderRadius={'19px'}
                        src={favVid.pictures.sizes[1].link}
                        width={'100%'}
                        height={'10vh'}
                        backgroundSize={'cover'}
                      />
                    </GenericColumn>
                    <GenericColumn
                      width={'66%'}
                      padding={'3% 5%'}
                      align={'flex-start'}
                      justify={'space-between'}
                      height={'100%'}
                    >
                      {favVid && favVid.is_locked && (
                        <GenericTextSpan
                          color={'#a1ff68'}
                          display={'block'}
                          width={'100%'}
                          tAlign={'right'}
                          fSize={'0.8rem'}
                        >
                          Niedostępny
                        </GenericTextSpan>
                      )}
                      <GenericTextSpan
                        fSize={isMobile ? '1rem' : '1.1rem'}
                        fWeight={'bold'}
                      >
                        {favVid && favVid.name}
                      </GenericTextSpan>
                      <GenericRow justify={'flex-start'}>
                        <GenericIcon
                          src={timeIcon}
                          width={
                            isMobile && !isTablet
                              ? '3vw'
                              : isTablet
                              ? '1.2vw'
                              : '0.75vw'
                          }
                          height={
                            isMobile && !isTablet
                              ? '3vw'
                              : isTablet
                              ? '1.2vw'
                              : '0.75vw'
                          }
                          margin={'0 5% 0 0'}
                        ></GenericIcon>
                        <GenericTextSpan>
                          {Math.floor(favVid && favVid.duration / 60)} minut
                        </GenericTextSpan>
                      </GenericRow>
                    </GenericColumn>
                  </AlbumTile>
                )
            )
          )
        ) : (
          <GenericTextSpan margin={'10% 0 0 0'}>
            Brak ulubionych{' '}
          </GenericTextSpan>
        )}
      </GenericColumn>
    </GenericColumn>
  )
}

export default FavoritesMode
